import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import terms from "../content/terms.json";
import privacy from "../content/privacy.json";

const documents = { terms, privacy };

export default function LegalModal({ type, onClose }) {
  const document = documents[type];
  if (!document) return null;
  return <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
    <DialogContent className="flex max-h-[85vh] w-[calc(100%-2rem)] max-w-2xl flex-col gap-0 overflow-hidden rounded-2xl bg-white p-0 text-[#1B2559]">
      <DialogHeader className="shrink-0 border-b border-[#E1E9FC] bg-[#EEF3FD] px-6 py-5 pr-12 text-left">
        <DialogTitle>{type === "terms" ? "Términos y Condiciones" : "Política de Privacidad"}</DialogTitle>
        <DialogDescription className="text-[#545454]">{document.updated}</DialogDescription>
      </DialogHeader>
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-6 py-5 text-sm leading-relaxed text-[#4A4A4A]">
        <h2 className="font-bold text-[#1B2559]">{document.title}</h2>
        <p className="text-xs text-[#687377]">{document.note}</p>
        {document.blocks.map((block, index) => {
          if (block.type === "heading") return <h3 key={index} className="pt-3 font-bold text-[#1B2559]">{block.text}</h3>;
          if (block.type === "table") return <div key={index} className="overflow-x-auto"><table className="w-full border-collapse text-left text-xs">
            <tbody>{block.rows.map((row, rowIndex) => <tr key={rowIndex}>{row.map((cell, cellIndex) => cellIndex === 0
              ? <th key={cellIndex} scope="row" className="border border-[#E1E9FC] bg-[#EEF3FD] p-2 font-semibold">{cell}</th>
              : <td key={cellIndex} className="border border-[#E1E9FC] p-2">{cell}</td>)}</tr>)}</tbody>
          </table></div>;
          return <p key={index}>{block.text}</p>;
        })}
      </div>
      <div className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-t border-[#E1E9FC] px-6 py-4">
        <a href={document.pdf} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#396BE9] underline">Abrir PDF original</a>
        <button type="button" onClick={onClose} className="rounded-full bg-[#396BE9] px-6 py-2.5 text-sm font-bold text-white">Cerrar</button>
      </div>
    </DialogContent>
  </Dialog>;
}
